<template>
  <Layout>
    <PageHeader :title="title" :items="items"> </PageHeader>
    <div class="row" id="questionBank">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row justify-content-center">
              <div class="col-lg-6">
                <b-card header-class="bg-transparent border-primary"
                  class="border border-primary d-flex justify-content-center">
                  <template v-slot:header>
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="my-0 text-primary d-flex">
                        <i class="ri-chat-upload-fill mr-1"></i>Upload Bulk
                      </h5>
                      <a href="/sample_questionbank.xlsx" download class="btn btn-primary btn-sm">
                        <i class="fa fa-download mr-1"></i> Download Sample File
                      </a>
                    </div>
                  </template>
                  <h5 class="card-title mt-0">Excel File:</h5>
                  <b-form-group class="mt-2" id="input-group-1"
                    label="Upload Excel File Here [Upload only .csv and .xlsx]" label-for="input-1">
                    <b-form-file
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      id="input-1" placeholder="Choose a file or drop it here..." ref="file"></b-form-file>
                  </b-form-group>
                  <b-button type="submit" variant="success" class="mr-2" @click.prevent="fetchExcel">Upload</b-button>
                </b-card>
              </div>
            </div>
            <div class="row align-items-center mb-4">
              <div class="col-md-6">
                <div class="form-inline navbar-search">
                  <div class="input-group">
                    <input name="title" class="form-control bg-light border-0 small" placeholder="Search Question"
                      aria-label="Search" aria-describedby="basic-addon2" v-model="filter" v-on:keyup="search" />
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="searchFor">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center justify-content-end" v-if="can('add-question-bank')">
                  <svg class="svg-inline--fa fa-table mx-2" height="16px" width="16px" aria-hidden="true"
                    focusable="false" data-prefix="fa" data-icon="table" role="img" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512" data-fa-i2svg="">
                    <path fill="currentColor"
                      d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z">
                    </path>
                  </svg>
                  <router-link :to="{ name: 'add-question-bank' }" class="opt">
                    Add Question Bank
                  </router-link>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table striped bordered :items="tableData.data" :fields="fields" :sort-by.sync="sortBy" :per-page="0"
                :current-page="currentPage" :sort-desc.sync="sortDesc" :filter-included-fields="filterOn"
                @filtered="onFiltered" responsive="sm" class="table-bordered table-hover" :key="key">
                <template v-slot:cell(is_mandatory)="row">
                  <span v-if="row.item.is_mandatory == 1">Yes</span>
                  <span v-else>No</span>
                </template>
                <template v-slot:cell(options)="row">
                  <div class="options">
                    <span v-for="option in JSON.parse(row.item.options)" :key="option.key"
                      class="badge border border-secondary p-2 m-1" style="font-size: 0.9rem">{{ option.value }}</span>
                  </div>
                </template>
                <template v-can="'edit-question-bank'" v-slot:cell(edit)="row">
                  <router-link :to="{
                    name: 'edit-question-bank',
                    params: { id: row.item.id },
                  }">
                    <i class="fa fa-edit edit-i"></i>
                  </router-link>
                </template>
                <template v-can="'delete-question-bank'" v-slot:cell(delete)="row">
                  <div @click.prevent="deleteQuestionBank(row.item.id)">
                    <i class="mdi mdi-trash-can delete-i"></i>
                  </div>
                </template>
              </b-table>
            </div>
            <template v-if="tableData.total_pages > 1">
              <div class="data_paginate">
                <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" first-number last-number :total-rows="tableData.total"
                      :total-pages="tableData.total_pages" :per-page="tableData.per_page"></b-pagination>
                  </ul>
                </div>
                <div class="form-inline navbar-search">
                  <span class="mr-2">Go to a Particular Paginated Page :</span>
                  <div class="input-group">
                    <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                    </b-form-input>
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="filterPage">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import questionBankMixin from "../../../mixins/ModuleJs/question-bank";

export default {
  mixins: [MixinRequest, questionBankMixin],
  data() {
    return {
      title: "Question Bank Management",
      items: [
        {
          text: "Home",
          href: "/",
        },

        {
          text: "List",
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>
